<template>
    <div class="app-modal-dialog--ai-create app-modal-dialog">
        <div class="app-modal-dialog__content">
            <div class="app-modal-dialog__header">
                <h4 class="app-modal-dialog__title">AI Generation: New Course</h4>
            </div>
            <form
                @submit.prevent="submit()"
                autocomplete="off">
                <div class="app-modal-dialog__body">
                    <fieldset class="input text" :disabled="disabled">
                        <label for="name">Course Title</label>
                        <input type="text" name="name" placeholder="i.e. Introduction to Fundamentals" v-model="publication.name" required>
                    </fieldset>
                    <fieldset class="input textarea" :disabled="disabled">
                        <label for="description">Description</label>
                        <textarea name="description" rows="3" v-model="publication.description"></textarea>
                    </fieldset>
                </div>
                <div class="app-modal-dialog__footer">
                    <app-button
                        theme="danger"
                        class="element-button--secondary element-button"
                        @click="cancel()">
                        Cancel
                    </app-button>
                    <app-button
                        theme="primary"
                        type="submit"
                        class="element-button--primary element-button"
                        :disabled="!requirementsMet || disabled">
                        {{ disabled ? 'Saving...' : 'Save' }}
                    </app-button>
                </div>
            </form>
        </div>
    </div>
</template>

<script>
import _ from 'lodash'
import api from '../api/publisher'

export default {
    props: {
        source: {
            type: Object,
            default: () => ({
                id: 'new-publication',
                name: '',
                description: ''
            })
        },
        project: {
            type: Object
        },
        isLiteMode: {
            type: Boolean,
            default: false
        },
        redirectOnCancel: {
            type: Boolean,
            default: true
        }
    },
    data () {
        const clonedSource = _.cloneDeep(this.source)
        return {
            publication: {
                ...clonedSource
            },
            disabled: false
        }
    },
    computed: {
        requirementsMet () {
            return this.publication.name.length
        }
    },
    methods: {
        cancel () {
            this.$emit('cancel')
            if (this.redirectOnCancel)
                window.location.href = '/projects/'+this.project.id+'/publications'
        },
        setDisabled(value = true) {
            this.disabled = value
        },
        async submit () {
            console.info('Saving page data...')

            const data = _.pick(this.publication, ['id', 'description', 'name'])
            data.ai = true;

            this.setDisabled(true)
            // save publication
            if (this.publication.id == 'new-publication') {

                // api call to save
                const result = await api.create(this.project.id, data)

                if (result.errors) {
                    // catch errors
                    this.setDisabled(false)
                    // TODO: display errors
                } else {
                    // redirect
                    if (this.isLiteMode)
                        window.location.href = '/publications/'+result.id+'/course-sources';
                    else
                        window.location.href = '/publications/'+result.id+'/ai-sources';
                }
            }
        }
    }
}
</script>
